export const identityKeys = {
  sso: (entityId: string) => ['identity', 'sso', entityId] as const,
  roleMappings: (entityId: string) => ['identity', 'sso-role-mappings', entityId] as const,
  oauthConsents: ['identity', 'oauth-consents'] as const,
  oauthConsentRequest: (clientId: string, scope: string) => ['identity', 'oauth-consent-request', clientId, scope] as const,
}
